module.exports = __webpack_public_path__ + "img/news_back.6f8343fa.png";